import React, { useEffect } from "react";
//outsource
import { Select } from "antd";

//components

//redux
import { useDispatch, useSelector } from "react-redux";
// import { staffsSelector } from "../../../../store/staff/staff.selector";
import { snapAllUsers, unSnapUsers } from "../../../../store/user/user.action";
import { usersSelector } from "../../../../store/user/user.selector";
// import {
//   snapAllStaffs,
//   unSnapStaffs,
// } from "../../../../store/staff/staff.action";

const DialogUserSearch = ({ setUserId }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const users = useSelector(usersSelector);
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setUserId(value);
  };

  const handleClear = () => {
    setUserId("");
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapAllUsers());
    return () => dispatch(unSnapUsers());
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const options = users ? convertData(users) : [];
  return (
    <Select
      style={{ width: "100%" }}
      placeholder="Search By Name.."
      allowClear
      showSearch
      options={options}
      onSelect={handleChange}
      onClear={handleClear}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    />
  );
};

export default DialogUserSearch;

const convertData = (data) => {
  const newData = data?.map((item) => {
    const label = `${item?.firstName} ${item?.lastName} (${item?.username})`;
    const value = item?.id;

    return {
      value,
      label,
    };
  });

  return newData;
};
